/**
 * OnboardingStep2.tsx - Continuing Education
 * Continuing education step of the onboarding flow.
 * Allows users to select continuing education areas.
 */
import React from "react";
import { View } from "react-native";
import ContinuingEducationEditor from "../preferences/editors/ContinuingEducationEditor";
import { spacingStyles } from "../../../styles/design-system";
import OnboardingStepHeader from "./common/OnboardingStepHeader";

export interface OnboardingStep2Props {
  selectedContinuingEducation: string[];
  onContinuingEducationChange: (value: string[]) => void;
}

function OnboardingStep2({ selectedContinuingEducation, onContinuingEducationChange }: OnboardingStep2Props) {
  return (
    <View style={spacingStyles.mNone}>
      <OnboardingStepHeader
        titleKey="companion_onboarding_step2_title"
        subtitleKey="companion_onboarding_step2_subtitle"
      />
      <ContinuingEducationEditor value={selectedContinuingEducation} onChange={onContinuingEducationChange} />
    </View>
  );
}

export default OnboardingStep2;
